module.exports = ".wContainer {\n    max-width: 1180px;\n    margin: 0 auto\n}\n\nsection.forMedia {\n  margin-bottom: 20px;\n }\n\n.paraCircuit{\n   width: 90%;\n   margin-left: 5%;\n }\n\n.btn-back{\n   margin-top: 70px;\n   margin-left: 10px;\n }\n\n@media screen and (max-width: 800px) {\n .container-for-gallery {\n     margin-bottom: 30%;\n }\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/media/photo-gallery/photo-gallery.component.css
// module id = ./src/app/media/photo-gallery/photo-gallery.component.css
// module chunks = main